import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { ScrollablePopoverDirective } from '../../../directives/scrollable-popover/scrollable-popover.directive';
import { ExportDisabled, ExportExtraOptions, ExportOnChange, ExportStreamOptions, ExportValidation } from '../../../models/export-stream-options';

@Component({
    standalone: false,
    selector: 'res-export-production-imaging-options',
    templateUrl: './export-production-imaging-options.component.html',
    styleUrls: ['./export-production-imaging-options.component.scss']
})
export class ExportProductionImagingOptionsComponent {
    @ViewChildren(ScrollablePopoverDirective) errorPopovers: QueryList<ScrollablePopoverDirective>;
    @Input() automationId: string;

    @Input() exportOptions: ExportStreamOptions;
    @Input() isExportVolume: boolean;
    @Input() optionsDisabled: boolean;
    @Input() updateExportVolume: boolean;

    @Input() extraOptions: ExportExtraOptions;
    @Input() onChange: ExportOnChange;
    @Input() disabled: ExportDisabled;
    @Input() validation: ExportValidation;
    @Input() isHyland: boolean;
    @Input() hideOptions = false;
    @Input() isReefReviewProject: boolean;
}
